class AuthorityAdvertisementAndActTypeModel {
    constructor(id = 0, sort  = "", description = ""){
        this.id = id;
        this.sort = sort;
        this.description = description;
    }
}

export default AuthorityAdvertisementAndActTypeModel;